import { render, staticRenderFns } from "./ProviderFareCell.vue?vue&type=template&id=00e7f5e4&scoped=true"
import script from "./ProviderFareCell.vue?vue&type=script&lang=js"
export * from "./ProviderFareCell.vue?vue&type=script&lang=js"
import style0 from "./ProviderFareCell.vue?vue&type=style&index=0&id=00e7f5e4&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00e7f5e4",
  null
  
)

export default component.exports